import { connect } from 'react-redux';
import {
  fetchPriceLevels,
  editMultiPriceLevels,
  fetchProductsByGroup,
  fetchGroups,
  fetchGroupCategories,
  fetchProductsByCategory,
  resetGroupAndCategory,
  selectProduct,
} from '../../actions/products_actions';
import {
  setOriginPage,
} from '../../actions/inventories_actions';

import PriceLevel from '../../components/Products/priceLevel';

function mapStateToProps(state) {
  return {
    groups: state.products.groups,
    priceLevels: state.products.priceLevels,
    isLoading: state.products.priceLevelIsLoading,
    error: state.products.priceLevelError,
    groupCategories: state.products.groupCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
    multiIsEditing: state.products.multiPriceLevelIsEditing,
    multiError: state.products.multiPriceLevelEditError,
    multiEdited: state.products.multiPriceLevelEdited,
  };
}

export default connect(mapStateToProps, {
  fetchGroups,
  fetchGroupCategories,
  fetchProductsByGroup,
  fetchProductsByCategory,
  resetGroupAndCategory,
  fetchPriceLevels,
  editMultiPriceLevels,
  selectProduct,
  setOriginPage,
})(PriceLevel);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/priceLevel.jsx